import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {CoreSidebarService} from '../../../@core/components/core-sidebar/core-sidebar.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {FormBuilder, FormGroup} from '@angular/forms';
import {NewsService} from '../../shared/services/news.service';
import {PopularLinksService} from '../../shared/services/popular-links.service';
import {AlertService} from '../../shared/services/alert.service';
import {ImageCroppedEvent} from 'ngx-image-cropper';

@Component({
    selector: 'app-news',
    templateUrl: './news.component.html',
    styleUrls: ['./news.component.scss']
})
export class NewsComponent implements OnInit {
    showSearch = false;
    id: any;
    data: any;
    submitted: any = false;
    submitting: any = false;
    searchForm: FormGroup;
    pagination = {
        page: 1,
        total: null,
        perpage: 15,
        pages: null
    };
    News = [];
    onFileChanged: any;
    viewContentData: any;
    modalType: any;
    imageChangedIconEvent: any;
    croppedIconImageEvent: any;
    croppedIconImage: any;
    popularLinks: any = [];
    popularLinkForm: FormGroup;
    popularLinkSubmitting: any = false;
    popularLinkTypes = [
        {value: 'BLOG', label: 'Blog Details Page (After Content)'},
        {value: 'LOCATION_WISE_COLLEGE', label: 'Top Universities in India (Home Page)'},
        {value: 'COURSE_WISE_COLLEGE', label: 'Course Wise Colleges Home Page'}
    ];
    popularLinkPagination = {
        page: 1,
        total: null,
        perpage: 10,
        pages: null
    };

    constructor(private router: Router,
                private _coreSidebarService: CoreSidebarService,
                public modalService: NgbModal,
                private fb: FormBuilder,
                private newservice: NewsService,
                private popularLinksService: PopularLinksService,
                private alertService: AlertService) {
        this.popularLinkForm = this.fb.group({
            'title': [''],
            'url': [''],
            'type': ['BLOG']
        });
    }

    ngOnInit(): void {
        this.refresh();
    }

    toggleSidebar(): void {
        this._coreSidebarService.getSidebarRegistry('add-news').toggleOpen();
    }

    add(): void {
        this.data = undefined;
        this.toggleSidebar();
    }

    refresh() {
        this.searchForm = this.fb.group({
            'category': [''],
            'heading': ['']
        });
        this.get();
    }

    getData(valueSubmit: any): void {
        if (valueSubmit) {
            this.get({page: 1, total: null, perpage: 15, pages: null});
            this.toggleSidebar();
        }
    }

    search() {
        const params = {
            'category': (this.searchForm.value && this.searchForm.value.category) ? this.searchForm.value.category : '',
            'heading': (this.searchForm.value && this.searchForm.value.heading) ? this.searchForm.value.heading : ''
        };
        this.get(params);
    }

    onPageChange(page) {
        this.pagination.page = page;
        const params = {
            category: (this.searchForm && this.searchForm.value && this.searchForm.value.category) ? this.searchForm.value.category : '',
            heading: (this.searchForm && this.searchForm.value && this.searchForm.value.heading) ? this.searchForm.value.heading : ''
        };
        this.get(params);
    }

    edit(data) {
        this.data = data;
        this.toggleSidebar();
    }

    get(params: any = {}) {
        params.page = this.pagination.page;
        params.per_page = this.pagination.perpage;
        this.submitting = true;
        this.News = [];
        this.newservice.get(params).subscribe(data => {
            if (data && data['data'].length > 0) {
               // console.log(data['data']);
                this.News = data['data'];
                this.pagination = {
                    page: data.current_page,
                    total: data.total,
                    perpage: data.per_page,
                    pages: data.last_page,
                };
            } else {
                this.News = [];
            }
            this.submitting = false;
        }, error => {
            this.submitting = false;
        });
    }

    NewsInfoPage(data: any) {
        this.router.navigateByUrl('news-info/' + data.id);
    }

    onFileChange(e, type, data) {
        this.onFileChanged = e;
        this.newservice.fileUploadAdmin({
            'type': type,
            'fileType': 'NORMAL',
            'news_id': data.id
        }, this.onFileChanged).subscribe(data => {
            if (type === 'NEWS_BANNER') {
                if (data && data['data']) {
                    this.get();
                }
            }
            this.alertService.showSuccess({title: 'Success', message: 'Uploaded Successfully'});
        }, error => {
            this.alertService.showErrors('Something went wrong, please try again');
        });
    }

    openNewsBanner(data) {
        window.open(data['banner']['url'], '_blank');
    }

    openInsightCover(data) {
        window.open(data['cover']['url'], '_blank');
    }

    viewContent(content, data) {
        this.modalType = 'NEWS_CONTENT';
        this.viewContentData = data;
        this.modalService.open(content, {'size': 'lg'});
    }

    imageIconCropped(event: ImageCroppedEvent) {
        this.croppedIconImageEvent = event;
        this.croppedIconImage = event.base64;
    }

    imageLoaded() {
        // show cropper
    }

    cropperReady() {
        // cropper ready
    }

    loadImageFailed() {
        // show message
    }

    fileChangeIconEvent(event: any): void {
        this.imageChangedIconEvent = event;
    }



    openNewsIconModal(content, id) {
        this.id = id;
        this.modalType = 'NEWS_ICON';
        this.modalService.open(content, {size: 'lg'});
    }

    openNewsIcon(data) {
        window.open(data['icon']['url'], '_blank');
    }

    updateStatus(status, data) {
        this.submitted = true;
        if (this.submitted) {
            const params = {
                'status': status
            };
            this.submitting = true;
            this.newservice.updateStatus(data.id, params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.id = undefined;
                this.get();
            }, error => {
                this.submitting = false;
                this.submitted = false;
                this.id = undefined;
            });
        }
    }

    openPopularLinksModal(content) {
        this.modalType = 'POPULAR_LINKS';
        this.popularLinkForm.reset({title: '', url: '', type: 'BLOG'});
        this.popularLinkPagination.page = 1;
        this.getPopularLinks();
        this.modalService.open(content, {size: 'lg'});
    }

    onPopularLinkTypeChange() {
        this.popularLinkPagination.page = 1;
        this.getPopularLinks();
    }

    onPopularLinkPageChange(page) {
        this.popularLinkPagination.page = page;
        this.getPopularLinks();
    }

    getPopularLinks() {
        const type = this.popularLinkForm.value.type;
        const params: any = {
            page: this.popularLinkPagination.page,
            per_page: this.popularLinkPagination.perpage
        };
        if (type) {
            params.type = type;
        }
        this.popularLinksService.get(params).subscribe(data => {
            if (data && data['data']) {
                if (data['data'].length === 0 && data.current_page > 1) {
                    this.popularLinkPagination.page = data.current_page - 1;
                    this.getPopularLinks();
                    return;
                }
                this.popularLinks = data['data'];
                this.popularLinkPagination = {
                    page: data.current_page,
                    total: data.total,
                    perpage: data.per_page,
                    pages: data.last_page
                };
            } else {
                this.popularLinks = [];
            }
        });
    }

    addPopularLink() {
        if (!this.popularLinkForm.value.title || !this.popularLinkForm.value.url || !this.popularLinkForm.value.type) {
            return;
        }
        this.popularLinkSubmitting = true;
        this.popularLinksService.create(this.popularLinkForm.value).subscribe(data => {
            this.popularLinkSubmitting = false;
            this.popularLinkForm.patchValue({title: '', url: ''});
            this.popularLinkPagination.page = 1;
            this.getPopularLinks();
        }, error => {
            this.popularLinkSubmitting = false;
        });
    }

    deletePopularLink(id) {
        this.popularLinksService.delete(id).subscribe(data => {
            this.getPopularLinks();
        });
    }
}
